import styled from "styled-components";
import React, { useState } from "react";
import { Box, Switch } from "@mui/material";
import FormField from "components/FormField";
import TextButton from "components/TextButton";
import { FormItem } from "components/ActionModal";
import { splitArrayIntoChunksOfLen } from "helper";
import ColorButton from "components/common/ColorButton";
import BlackSelect from "components/common/BlackSelect";
import { FiberManualRecord } from "@mui/icons-material";
import TooltipIconButton from "components/TooltipIconButton";
import { Colors, PinSizes, Markers, LabelSizes, LabelColors } from "constant";

const Wrapper = styled(Box)`
  position: relative;
  border: 1px solid #a8a8a8;
  border-radius: 0.25rem;
`;

const Label = styled.p`
  position: absolute;
  left: 10px;
  top: -9px;
  background: #2F2F2F;
  z-index: 1;
  font-size: 1.2rem;
  padding: 0 5px;
`;

const DisplaySection = styled.div`
`;

const DisplayOptions = styled.div`
  margin: 20px 0 0;
`;

const MarkerItem = styled(Box)`
  background: #FFFFFF;
  width: 30px;
  height: 30px;
  border-radius: 30px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  
  span {
    font-size: 18px;
    color: #2F2F2F;
  }
`;

const FormGroups = styled.div`
  margin-top: 25px;
  display: inline-flex;
  grid-gap: 14px;
  width: 100%;

  & > * {
    flex-basis: 50%;
  } 
`;

const LabelColor = styled.div`
  fieldset {
    padding: 10px;
    border: 1px solid #a8a8a8;
    border-radius: .25rem;

    label {
      margin: 0;
    }
  }
`;

const ShowMeasurements = styled(Box)`
  padding: 5px 10px;
  background: #232323;
  border-radius: 3px;

  h4 {
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    color: #C4C4C4;
  }

  .MuiSwitch-switchBase {
    position: absolute !important;
  }

  .MuiSwitch-colorPrimary {
    color: #487BF2 !important;
  }

  .MuiSwitch-track {
    background-color: #707173 !important;
  }
`;

const ColorIndicator = styled.div`
  svg {
    fill: ${props => props.color ? props.color + " !important" : ""};
  }
`;

const labels = [
  { label: 'Show', value: 1 },
  { label: 'Hide', value: 2 }
];

const MarkerPicker = (props) => {
  const { label, setPickedPin, setPickedPinsize, setpincolor, Labelsizevalue } = props;
  const [pinSize, setPinSize] = useState(PinSizes[0]);
  const [activeShow, setActiveShow] = useState('marker');
  const [pinColor, setPinColor] = useState(null);
  const [showOptions, setShowOptions] = useState(false);
  const [labelColor, setLabelColor] = useState(null);
  const [showMeasureMents, setShowMeasureMents] = useState(false);

  const handleChangePinSize = (value) => {
    setPinSize(PinSizes.find(item => item.value === value));
    setPickedPinsize(value);
  };

  const PickedPin = (item) => {
    setPickedPin(item);
  };

  const showAddColorPicker = () => {
    setActiveShow('color');
  };

  const handlePinColor = (value) => {
    setPinColor(value);
    setActiveShow('marker');
    setpincolor(value);
  };

  const toggleOptions = () => {
    setShowOptions(!showOptions);
  };

  const handleLabel = (e) => {
    
  };

  const handleLabelSize = (e) => {
    Labelsizevalue(e.target.value);
  };

  const handleLabelColor = (value) => {
    setLabelColor(value);
  };

  const handleShowMeasureMents = (e) => {
    setShowMeasureMents(e.target.checked)
  };

  return (
    <Wrapper p="20px" mb="2rem">
      <Label>{label}</Label>
      <Box display="flex" justifyContent="space-between" pr="6px">
        <FormItem>
          <BlackSelect options={PinSizes} value={pinSize.value} onChange={(value) => handleChangePinSize(value)} tooltip="true" tooltipTitle="Pin Size" tooltipLabel="Pin-size" tooltipPlacement="right" />
        </FormItem>
        <ColorIndicator color={pinColor}>
          <TooltipIconButton title="Pin Color" ariaLabel="pin-color" placement="right" size={34} onClick={showAddColorPicker}>
            <FiberManualRecord />
          </TooltipIconButton>
        </ColorIndicator>
      </Box>
      <DisplaySection>
        {
          activeShow === "marker" ?
          <>
            {splitArrayIntoChunksOfLen(Markers, 8).map((itemList, index) => (
              <Box display="flex" flexDirection="row" mt="9px" key={index} >
                {itemList.map((item, itemIndex) => (
                  <MarkerItem mr="8px" key={itemIndex} onClick={() => PickedPin(item)}>
                    <span className="material-icons-outlined">{item}</span>
                  </MarkerItem>
                ))}
              </Box>
            ))}
          </> 
          :
          <>
            {splitArrayIntoChunksOfLen(Colors, 8).map((itemList, index) => (
              <Box display="flex" flexDirection="row" mt="9px" key={index}>
                {itemList.map((item, itemIndex) => (
                  <Box mr="8px" key={itemIndex}>
                    <ColorButton color={item} active={pinColor === item} onClick={() => handlePinColor(item)} />
                  </Box>
                ))}
              </Box>
            ))}
          </>
        }
      </DisplaySection>
      <DisplayOptions>
        <TextButton onClick={toggleOptions} text={showOptions ? "Hide Options" : "Display Options"} />
        {showOptions &&
          <>
            <FormGroups>
              <FormField label="Label" id="project_label">
                <select id="project_label" onChange={handleLabel}>
                  {labels.map(item => <option value={item.value} key={item.value}>{item.label}</option>)}
                </select>
              </FormField>
              <FormField label="Label Size" id="project_label_size">
                <select id="project_label_size" onChange={handleLabelSize}>
                  {LabelSizes.map(item => <option value={item.value} key={item.value}>{item.label}</option>)}
                </select>
              </FormField>
            </FormGroups>
            <LabelColor>
              <FormField label="Label Color" id="label_color" className="label-color">
                <Box display="flex" flexDirection="row">
                  {LabelColors.map((color, index) => (
                    <Box mr="6px" key={index}>
                      <ColorButton color={color} active={labelColor === color} onClick={() => handleLabelColor(color)} />
                    </Box>
                  ))}
                </Box>
              </FormField>
            </LabelColor>
            <ShowMeasurements display="flex" justifyContent="space-between" alignItems="center">
              <h4>Pin Location</h4>
              <Switch checked={showMeasureMents} onChange={handleShowMeasureMents} name="show_measurements" color="primary" />
            </ShowMeasurements>
          </>}
      </DisplayOptions>
    </Wrapper>
  );
};

export default MarkerPicker;